import React, { useEffect, useState } from 'react'
import Cards from './accounting/Cards'
import Transactions from './accounting/Transactions'
import Invoices from './accounting/Invoices'

export default function AccountingTab({
  accountingData, getAccountingDataPath, invoicesPath, setAccountingData, setLoading, transactionsPath
}) {
  const [transactions, setTransactions] = useState([])
  const [invoices, setInvoices] = useState([])

  useEffect(() => {
    if (!accountingData) {
      setLoading(true)

      Rails.ajax({
        type: 'GET',
        url: getAccountingDataPath,
        dataType: 'json',
        success: res => {
          setAccountingData(res.accountingData)
          setLoading(false)
        }
      })
    }
  }, [])

  return (
    <>
      { !!accountingData &&
        <>
          { accountingData.billing &&
            <div className="col s12">
              <div className="card">
                <div className="card-content">
                  <div className="card-title">Billing Information</div>
                  <div className="card-body">
                    <table>
                      <thead>
                        <tr><th></th></tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>First Name</td>
                          <td>{ accountingData.billing.firstName || '-' }</td>
                        </tr>
                        <tr>
                          <td>Last Name</td>
                          <td>{ accountingData.billing.lastName || '-' }</td>
                        </tr>
                        <tr>
                          <td>Company</td>
                          <td>{ accountingData.billing.company || '-' }</td>
                        </tr>
                        <tr>
                          <td>VAT Number</td>
                          <td>{ accountingData.billing.vatNumber || '-' }</td>
                        </tr>
                        <tr>
                          <td>Phone</td>
                          <td>{ accountingData.billing.phone || '-' }</td>
                        </tr>
                        <tr>
                          <td>Mobile Phone</td>
                          <td>{ accountingData.billing.mobile_phone || '-' }</td>
                        </tr>
                        <tr>
                          <td>Invoicing Email</td>
                          <td>{ accountingData.billing.email || '-' }</td>
                        </tr>
                        <tr>
                          <td>Billing Address</td>
                          <td>{ accountingData.billing.street || '-' }</td>
                        </tr>
                        <tr>
                          <td>Postal Code</td>
                          <td>{ accountingData.billing.postalCode || '-' }</td>
                        </tr>
                        <tr>
                          <td>City</td>
                          <td>{ accountingData.billing.city || '-' }</td>
                        </tr>
                        <tr>
                          <td>State/Province</td>
                          <td>{ accountingData.billing.state || '-' }</td>
                        </tr>
                        <tr>
                          <td>Country</td>
                          <td>{ accountingData.billing.country || '-' }</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          }

          <Cards
            cards={ accountingData.cards }
          />

          <Transactions
            transactions={ transactions }
            setTransactions={ setTransactions }
            transactionsPath={ transactionsPath }
          />

          <Invoices
            invoices={ invoices }
            setInvoices={ setInvoices }
            invoicesPath={ invoicesPath }
          />
        </>
      }
    </>
  )
}
